import { FindingAPI } from '../../lib/api';

export const RECIEVE_FINDING = 'FINDINGS.RECIEVE_FINDING';
export const REMOVE_FINDING = 'FINDINGS.REMOVE_FINDING';
export const FETCH_FINDINGS = 'FINDINGS.FETCH_FINDINGS';
export const RECIEVE_FINDINGS = 'FINDINGS.RECIEVE_FINDINGS';
export const TOGGLE_FINDING_MESSAGE = 'FINDINGS.TOGGLE_FINDING_MESSAGE';
export const UPDATE_FINDING_FIELD = 'FINDINGS.UPDATE_FINDING_FIELD';

const API = new FindingAPI();

const recieveFinding = ({ finding }) => ({
  type: RECIEVE_FINDING,
  finding,
});

const recieveFindings = ({ findings, constants }) => ({
  type: RECIEVE_FINDINGS,
  findings,
  constants,
});

const removeFinding = ({ finding }) => ({
  type: REMOVE_FINDING,
  finding,
});

export const toggleTextbox = ({ id }) => dispatch =>
  dispatch({
    type: TOGGLE_FINDING_MESSAGE,
    id,
  });

export const updateField = ({ id, value, field }) => dispatch =>
  dispatch({
    type: UPDATE_FINDING_FIELD,
    id,
    value,
    field,
  });


export const addOwner = ({
  findingId,
  personId,
  ownerId,
  ownerType,
}) => (dispatch) => {
  API.addOwner({
    findingId,
    personId,
    ownerId,
    ownerType,
  }).then((finding) => {
    dispatch(recieveFinding(finding));
  }).catch((error) => {
    console.error(error);
  });
};


export const fetchFindings = ({
  personId,
  orgId,
  jurisdiction,
  withoutJurisdiction,
}) => (dispatch) => {
  dispatch(recieveFindings({ findings: [] }));
  API.get({
    personId,
    orgId,
    jurisdiction: withoutJurisdiction ? `-${withoutJurisdiction}` : jurisdiction,
  }).then((data) => {
    dispatch(recieveFindings(data));
  }).catch((error) => {
    // dispatch(recieveFindings({ findings: [], constants: {} }));
    console.log('Could not retrieve findings.');
    console.log(error);
  });
};

export const submitWorkflowQuestion = ({
  findingId, questionId, answerText, type, personId,
}) => (dispatch, getState) => {
  API.submitQuestion({
    findingId, questionId, answerText, type, personId,
  }).then(({ finding }) => {
    if (finding) {
      if (finding.status === getState().findings.get('constants').status.fromName('Resolved').id) {
        setTimeout(() => dispatch(removeFinding({ finding })), 400);
      }
      dispatch(recieveFinding({ finding }));
    } else {
      throw new Error('Updated finding was not returned.');
    }
  }).catch(error => console.error('Failed to submit answer.', { error }));
};



// WEBPACK FOOTER //
// ./src/redux/actions/Findings.js